export default __webpack_public_path__ + "static/media/bgCloudMb.c845db34.png";